import { z } from "zod";
import { KlaerpunktSchema } from "./common.js";

/**
 * Phase 97 — Klärpunkte über die ganze Pipeline gesammelt.
 * Hängt nicht an einer einzelnen Phase, wird inkrementell befüllt.
 */
export const KlaerpunkteSchema = z.object({
  schemaVersion: z.literal(1).default(1),
  punkte: z.array(KlaerpunktSchema).default([]),
});

export type Klaerpunkte = z.infer<typeof KlaerpunkteSchema>;
